var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "card-header text-center border-bottom-0" }, [
      _c("h1", { staticClass: "h4" }, [_vm._v(_vm._s(_vm.$t("design.colors")))])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "card-body grid-kernel system_colors" },
      [
        _c("h3", { staticClass: "border-bottom pb-2 mb-3" }, [
          _vm._v("Main colors")
        ]),
        _vm._v(" "),
        _c(
          "b-row",
          [
            _c("b-col", { attrs: { lg: "3" } }, [
              _c("div", { staticClass: "card brandingColor" }, [
                _c("div", { staticClass: "card-body" }),
                _vm._v(" "),
                _c("div", { staticClass: "card-footer" }, [
                  _c("em", [_vm._v("$brandingColor")]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v("\n            HEX "),
                  _c("span")
                ])
              ])
            ]),
            _vm._v(" "),
            _c("b-col", { attrs: { lg: "2" } }, [
              _c("div", { staticClass: "card accentColor" }, [
                _c("div", { staticClass: "card-body" }),
                _vm._v(" "),
                _c("div", { staticClass: "card-footer" }, [
                  _c("em", [_vm._v("$accentColor")]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v("\n            HEX "),
                  _c("span")
                ])
              ])
            ]),
            _vm._v(" "),
            _c("b-col", { attrs: { lg: "3" } }, [
              _c("div", { staticClass: "card secondaryColor" }, [
                _c("div", { staticClass: "card-body" }),
                _vm._v(" "),
                _c("div", { staticClass: "card-footer" }, [
                  _c("em", [_vm._v("$secondaryColor")]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v("\n            HEX "),
                  _c("span")
                ])
              ])
            ]),
            _vm._v(" "),
            _c("b-col", { attrs: { lg: "2" } }, [
              _c("div", { staticClass: "card auxColor" }, [
                _c("div", { staticClass: "card-body" }),
                _vm._v(" "),
                _c("div", { staticClass: "card-footer" }, [
                  _c("em", [_vm._v("$auxColor")]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v("\n            HEX "),
                  _c("span")
                ])
              ])
            ]),
            _vm._v(" "),
            _c("b-col", { attrs: { lg: "2" } }, [
              _c("div", { staticClass: "card aquaColor" }, [
                _c("div", { staticClass: "card-body" }),
                _vm._v(" "),
                _c("div", { staticClass: "card-footer" }, [
                  _c("em", [_vm._v("$aquaColor")]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v("\n            HEX "),
                  _c("span")
                ])
              ])
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "b-row",
          { staticClass: "mt-4" },
          [
            _c("b-col", { attrs: { lg: "3" } }, [
              _c("div", { staticClass: "card brandingColorHover" }, [
                _c("div", { staticClass: "card-body" }),
                _vm._v(" "),
                _c("div", { staticClass: "card-footer" }, [
                  _c("em", [_vm._v("$brandingColorHover")]),
                  _c("br"),
                  _vm._v("\n            HEX "),
                  _c("span")
                ])
              ])
            ]),
            _vm._v(" "),
            _c("b-col", { attrs: { lg: "2" } }, [
              _c("div", { staticClass: "card accentColorHover" }, [
                _c("div", { staticClass: "card-body" }),
                _vm._v(" "),
                _c("div", { staticClass: "card-footer" }, [
                  _c("em", [_vm._v("$accentColorHover")]),
                  _c("br"),
                  _vm._v("\n            HEX "),
                  _c("span")
                ])
              ])
            ]),
            _vm._v(" "),
            _c("b-col", { attrs: { lg: "3" } }, [
              _c("div", { staticClass: "card secondaryColorHover" }, [
                _c("div", { staticClass: "card-body" }),
                _vm._v(" "),
                _c("div", { staticClass: "card-footer" }, [
                  _c("em", [_vm._v("$secondaryColorHover")]),
                  _c("br"),
                  _vm._v("\n            HEX "),
                  _c("span")
                ])
              ])
            ]),
            _vm._v(" "),
            _c("b-col", { attrs: { lg: "2" } }, [
              _c("div", { staticClass: "card auxColorHover" }, [
                _c("div", { staticClass: "card-body" }),
                _vm._v(" "),
                _c("div", { staticClass: "card-footer" }, [
                  _c("em", [_vm._v("$auxColorHover")]),
                  _c("br"),
                  _vm._v("\n            HEX "),
                  _c("span")
                ])
              ])
            ]),
            _vm._v(" "),
            _c("b-col", { attrs: { lg: "2" } }, [
              _c("div", { staticClass: "card aquaColorHover" }, [
                _c("div", { staticClass: "card-body" }),
                _vm._v(" "),
                _c("div", { staticClass: "card-footer" }, [
                  _c("em", [_vm._v("$aquaColorHover")]),
                  _c("br"),
                  _vm._v("\n            HEX "),
                  _c("span")
                ])
              ])
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c("h4", { staticClass: "mt-4 mb-4" }, [_vm._v("State colors")]),
        _vm._v(" "),
        _c(
          "b-row",
          [
            _c("b-col", { attrs: { lg: "3" } }, [
              _c("div", { staticClass: "card bootInfo" }, [
                _c("div", { staticClass: "card-body" }),
                _vm._v(" "),
                _c("div", { staticClass: "card-footer" }, [
                  _c("em", [_vm._v("$bootInfo")]),
                  _c("br"),
                  _vm._v("\n            HEX "),
                  _c("span")
                ])
              ])
            ]),
            _vm._v(" "),
            _c("b-col", { attrs: { lg: "3" } }, [
              _c("div", { staticClass: "card bootSuccess" }, [
                _c("div", { staticClass: "card-body" }),
                _vm._v(" "),
                _c("div", { staticClass: "card-footer" }, [
                  _c("em", [_vm._v("$bootSuccess")]),
                  _c("br"),
                  _vm._v("\n            HEX "),
                  _c("span")
                ])
              ])
            ]),
            _vm._v(" "),
            _c("b-col", { attrs: { lg: "3" } }, [
              _c("div", { staticClass: "card bootDanger" }, [
                _c("div", { staticClass: "card-body" }),
                _vm._v(" "),
                _c("div", { staticClass: "card-footer" }, [
                  _c("em", [_vm._v("$bootDanger")]),
                  _c("br"),
                  _vm._v("\n            HEX "),
                  _c("span")
                ])
              ])
            ]),
            _vm._v(" "),
            _c("b-col", { attrs: { lg: "3" } }, [
              _c("div", { staticClass: "card bootWarning" }, [
                _c("div", { staticClass: "card-body" }),
                _vm._v(" "),
                _c("div", { staticClass: "card-footer" }, [
                  _c("em", [_vm._v("$bootWarning")]),
                  _c("br"),
                  _vm._v("\n            HEX "),
                  _c("span")
                ])
              ])
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "b-row",
          { staticClass: "mt-4" },
          [
            _c("b-col", { attrs: { lg: "3" } }, [
              _c("div", { staticClass: "card bootInfoHover" }, [
                _c("div", { staticClass: "card-body" }),
                _vm._v(" "),
                _c("div", { staticClass: "card-footer" }, [
                  _c("em", [_vm._v("$bootInfoHover")]),
                  _c("br"),
                  _vm._v("\n            HEX "),
                  _c("span")
                ])
              ])
            ]),
            _vm._v(" "),
            _c("b-col", { attrs: { lg: "3" } }, [
              _c("div", { staticClass: "card bootSuccessHover" }, [
                _c("div", { staticClass: "card-body" }),
                _vm._v(" "),
                _c("div", { staticClass: "card-footer" }, [
                  _c("em", [_vm._v("$bootSuccessHover")]),
                  _c("br"),
                  _vm._v("\n            HEX "),
                  _c("span")
                ])
              ])
            ]),
            _vm._v(" "),
            _c("b-col", { attrs: { lg: "3" } }, [
              _c("div", { staticClass: "card bootDangerHover" }, [
                _c("div", { staticClass: "card-body" }),
                _vm._v(" "),
                _c("div", { staticClass: "card-footer" }, [
                  _c("em", [_vm._v("$bootDangerHover")]),
                  _c("br"),
                  _vm._v("\n            HEX "),
                  _c("span")
                ])
              ])
            ]),
            _vm._v(" "),
            _c("b-col", { attrs: { lg: "3" } }, [
              _c("div", { staticClass: "card bootWarningHover" }, [
                _c("div", { staticClass: "card-body" }),
                _vm._v(" "),
                _c("div", { staticClass: "card-footer" }, [
                  _c("em", [_vm._v("$bootWarningHover")]),
                  _c("br"),
                  _vm._v("\n            HEX "),
                  _c("span")
                ])
              ])
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c("h4", { staticClass: "mt-4 mb-4" }, [_vm._v("Gray colors")]),
        _vm._v(" "),
        _c(
          "b-row",
          [
            _c("b-col", { attrs: { lg: "3" } }, [
              _c("div", { staticClass: "card altColor" }, [
                _c("div", { staticClass: "card-body" }),
                _vm._v(" "),
                _c("div", { staticClass: "card-footer" }, [
                  _c("em", [_vm._v("$altColor")]),
                  _c("br"),
                  _vm._v("\n            HEX "),
                  _c("span")
                ])
              ])
            ]),
            _vm._v(" "),
            _c("b-col", { attrs: { lg: "3" } }, [
              _c("div", { staticClass: "card borderColor" }, [
                _c("div", { staticClass: "card-body" }),
                _vm._v(" "),
                _c("div", { staticClass: "card-footer" }, [
                  _c("em", [_vm._v("$borderColor")]),
                  _c("br"),
                  _vm._v("\n            HEX "),
                  _c("span")
                ])
              ])
            ]),
            _vm._v(" "),
            _c("b-col", { attrs: { lg: "3" } }, [
              _c("div", { staticClass: "card fontColor" }, [
                _c("div", { staticClass: "card-body" }),
                _vm._v(" "),
                _c("div", { staticClass: "card-footer" }, [
                  _c("em", [_vm._v("$fontColor")]),
                  _c("br"),
                  _vm._v("\n            HEX "),
                  _c("span")
                ])
              ])
            ]),
            _vm._v(" "),
            _c("b-col", { attrs: { lg: "3" } }, [
              _c("div", { staticClass: "card bodyBg" }, [
                _c("div", { staticClass: "card-body" }),
                _vm._v(" "),
                _c("div", { staticClass: "card-footer" }, [
                  _c("em", [_vm._v("$bodyBg")]),
                  _c("br"),
                  _vm._v("\n            HEX "),
                  _c("span")
                ])
              ])
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c("h3", { staticClass: "border-bottom pb-2 mb-4 mt-4" }, [
          _vm._v("R web-safe colors")
        ]),
        _vm._v(" "),
        _c(
          "b-row",
          [
            _c("b-col", { attrs: { lg: "3" } }, [
              _c("div", { staticClass: "card brandingColorWeb" }, [
                _c("div", { staticClass: "card-body" }),
                _vm._v(" "),
                _c("div", { staticClass: "card-footer" }, [
                  _c("em", [_vm._v("$brandingColorWeb")]),
                  _c("br"),
                  _vm._v("\n            HEX "),
                  _c("span")
                ])
              ])
            ]),
            _vm._v(" "),
            _c("b-col", { attrs: { lg: "2" } }, [
              _c("div", { staticClass: "card accentColorWeb" }, [
                _c("div", { staticClass: "card-body" }),
                _vm._v(" "),
                _c("div", { staticClass: "card-footer" }, [
                  _c("em", [_vm._v("$accentColorWeb")]),
                  _c("br"),
                  _vm._v("\n            HEX "),
                  _c("span")
                ])
              ])
            ]),
            _vm._v(" "),
            _c("b-col", { attrs: { lg: "3" } }, [
              _c("div", { staticClass: "card secondaryColorWeb" }, [
                _c("div", { staticClass: "card-body" }),
                _vm._v(" "),
                _c("div", { staticClass: "card-footer" }, [
                  _c("em", [_vm._v("$secondaryColorWeb")]),
                  _c("br"),
                  _vm._v("\n            HEX "),
                  _c("span")
                ])
              ])
            ]),
            _vm._v(" "),
            _c("b-col", { attrs: { lg: "2" } }, [
              _c("div", { staticClass: "card auxColorWeb" }, [
                _c("div", { staticClass: "card-body" }),
                _vm._v(" "),
                _c("div", { staticClass: "card-footer" }, [
                  _c("em", [_vm._v("$auxColorWeb")]),
                  _c("br"),
                  _vm._v("\n            HEX "),
                  _c("span")
                ])
              ])
            ]),
            _vm._v(" "),
            _c("b-col", { attrs: { lg: "2" } }, [
              _c("div", { staticClass: "card aquaColorWeb" }, [
                _c("div", { staticClass: "card-body" }),
                _vm._v(" "),
                _c("div", { staticClass: "card-footer" }, [
                  _c("em", [_vm._v("$aquaColorWeb")]),
                  _c("br"),
                  _vm._v("\n            HEX "),
                  _c("span")
                ])
              ])
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "b-row",
          { staticClass: "mt-4" },
          [
            _c("b-col", { attrs: { lg: "3" } }, [
              _c("div", { staticClass: "card bootInfoWeb" }, [
                _c("div", { staticClass: "card-body" }),
                _vm._v(" "),
                _c("div", { staticClass: "card-footer" }, [
                  _c("em", [_vm._v("$bootInfoWeb")]),
                  _c("br"),
                  _vm._v("\n            HEX "),
                  _c("span")
                ])
              ])
            ]),
            _vm._v(" "),
            _c("b-col", { attrs: { lg: "3" } }, [
              _c("div", { staticClass: "card bootSuccessWeb" }, [
                _c("div", { staticClass: "card-body" }),
                _vm._v(" "),
                _c("div", { staticClass: "card-footer" }, [
                  _c("em", [_vm._v("$bootSuccessWeb")]),
                  _c("br"),
                  _vm._v("\n            HEX "),
                  _c("span")
                ])
              ])
            ]),
            _vm._v(" "),
            _c("b-col", { attrs: { lg: "3" } }, [
              _c("div", { staticClass: "card bootDangerWeb" }, [
                _c("div", { staticClass: "card-body" }),
                _vm._v(" "),
                _c("div", { staticClass: "card-footer" }, [
                  _c("em", [_vm._v("$bootDangerWeb")]),
                  _c("br"),
                  _vm._v("\n            HEX "),
                  _c("span")
                ])
              ])
            ]),
            _vm._v(" "),
            _c("b-col", { attrs: { lg: "3" } }, [
              _c("div", { staticClass: "card bootWarningWeb" }, [
                _c("div", { staticClass: "card-body" }),
                _vm._v(" "),
                _c("div", { staticClass: "card-footer" }, [
                  _c("em", [_vm._v("$bootWarningWeb")]),
                  _c("br"),
                  _vm._v("\n            HEX "),
                  _c("span")
                ])
              ])
            ])
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Pages/Styles/Colors.vue?vue&type=template&id=2c10b932&scoped=true&
// module id = null
// module chunks = 